import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: any) => ({
  printWrapper: {
    // backgroundColor: "red",
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    width: "97vw",
    padding: 0,
    '@media print': {
      display: 'inherit',
      flexDirection: 'inherit',
      minHeight: 0,
    },
  },
  content: {
    flexGrow: 1,
    padding: 0,
    minHeight: "70vh",
    marginBottom: "50px",
    '@media print': {
      minHeight: 0,
      marginBottom: 0,
    },
  },

}));

export default useStyles;